import { SegmentControl } from "@/components/SegmentControl";
import BlokWrap from "@/components/bloks/BlokWrap";
import { RichTextRender } from "@/components/ui/RichTextRender";
import type { BlokTextImage } from "@/storyblok";
import type { BlokProps } from "@frend-digital/storyblok";
import { AssetBlok, multiAssetToSingleAsset, sizes } from "../Asset";
import { MediaLink } from "../MediaLink";
import styles from "./TextImage.module.css";
import { TextImageColorWrap } from "./TextImageColorWrap";

export const TextImageBlok = ({ blok, preview }: BlokProps<BlokTextImage>) => {
	const isWhiteOrEmpty = !blok.backgroundColor || blok.backgroundColor === "#ffffff";

	return (
		<SegmentControl segments={blok}>
			<BlokWrap editable={blok} asChild>
				<div className={styles.content}>
					<div
						className={styles.media}
						data-reversed={blok.reversed}
						data-full-radius={isWhiteOrEmpty}
						data-height={(blok.height || undefined) as "small" | "medium" | "large" | undefined}
						data-height-mobile={
							(blok.heightMobile || undefined) as "small" | "medium" | "large" | undefined
						}
						data-aspect-ratio={
							(blok.aspectRatio || undefined) as "1:1" | "4:5" | "5:4" | "4:3" | "16:9" | undefined
						}
						data-aspect-ratio-mobile={
							(blok.aspectRatioMobile || undefined) as
								| "1:1"
								| "4:5"
								| "5:4"
								| "4:3"
								| "16:9"
								| undefined
						}
					>
						{blok.media && (
							<MediaLink link={blok.mediaLink} contentType={blok.component} itemId={blok._uid}>
								<AssetBlok
									autoPlay
									muted
									loop
									source={multiAssetToSingleAsset(blok.media)}
									sizes={sizes(100, 80)}
								/>
							</MediaLink>
						)}
					</div>

					<TextImageColorWrap backgroundColor={blok.backgroundColor} reversed={blok.reversed}>
						{blok.text && <RichTextRender blok={blok.text} preview={preview} />}
					</TextImageColorWrap>
				</div>
			</BlokWrap>
		</SegmentControl>
	);
};
